export default __webpack_public_path__ + "static/media/sc_en.9dcc26a8.png";